import * as _ from "lodash";

class SequencerStatus {
	static Invalid = {title: "Invalid", val: 0, icon: "mdi-circle", color: "grey"}
	static Offline = {title: "Offline", val: 1, icon: "mdi-circle", color: "red"}
	static OnAir = {title: "Online", val: 2, icon: "mdi-circle", color: "green"}
	static Idle = {title: "Idle", val: 3, icon: "mdi-circle", color: "orange"}
	static PlayerOffLine = {title: "Player OffLine", val: 4, icon: "mdi-circle", color: "grey"}
	static IdlePaused = {title: "Idle Paused", val: 5, icon: "mdi-pause-circle", color: "orange"}
	static OnAirPaused = {title: "On-Air Paused", val: 6, icon: "mdi-pause-circle", color: "green"}
	static ContentStoreOffline = {title: "Content Store Offline", val: 7, icon: "mdi-circle", color: "red"}

	static getByValue = (value) => {
		if (value) {
			return _.values(this).find(status => status.val === value);
		}

		return value;
	}
}

export default SequencerStatus;